import React from "react"
import SEO from "../components/seo"
import "./awardees.css"
import logo from "../images/logo.png"

const DealerAwardees = () => {
  const awardees = [
    "Emersen Berndt",
    "Meghan Milligan",
    "Kathryn Van Buskirk",
    "Lily Boutelle",
    "Blake Petersen",
    "JJ Vander Loop",
    "Carleena Deforges",
    "Kali Siembor",
    "Melia Warner",
    "Sabina Memet",
    "Jonathan Tousignant",
    "Adam Windorski",
  ];

  return (
    <div className="awardees">
      <img className="logo" src={logo} />
      <h2 className="awardee-header">We are pleased to announce the 2025 Brunswick Dealer Sons &amp; Daughters Scholarship Program Awardees</h2>
      <div className="awardee-grid">
        {awardees.map((awardee) => <span>{awardee}</span>)}
      </div>
    </div>
  );
};

export default DealerAwardees
